import { createAction } from 'redux-actions';
import { PagePrivileges } from '../../types/pagePrivileges';

export const fetchPagePrivilegesSuccess = createAction(
  'PAGE.PRIVILEGES.FETCH.SUCCESS',
  (payload: PagePrivileges) => payload
);
